import ko from 'knockout';

/**
 * AboutViewModel - Manages state and logic for the About view
 * - Provides a list of about images
 * - Can be extended to load about content from Firestore if needed
 * - Locale-agnostic by design
 */

class AboutViewModel {
    /**
     * @param {Object} options
     * @param {function} [options.t] - Translation function (key, params, lang)
     * @param {ko.Observable} [options.currentLang] - Current language observable
     * @param {string} [options.aboutContent] - Optional about content
     */
    constructor(options = {}) {
        this.t = options.t || ((key) => key);
        this.currentLang = options.currentLang || ko.observable('en');

        // List of about text items with Tailwind styling
        this.aboutTexts = ko.observableArray([
            {
                text: 'Crafting digital excellence.',
                classes: 'text-3xl font-black italic tracking-tight text-transparent bg-clip-text bg-gradient-to-b from-yellow-300 to-yellow-500 drop-shadow-[0_0_8px_rgba(59,130,246,0.8)]'
            },
            {
                text: 'Elegant by design.',
                classes: 'text-3xl font-black text-transparent bg-clip-text bg-gradient-to-b from-cyan-200 to-cyan-400 drop-shadow-[2px_2px_0px_rgba(88,28,135,1)]'
            },
            {
                text: 'Built to last.',
                classes: 'text-3xl font-black text-transparent bg-clip-text bg-gradient-to-b from-pink-200 to-pink-500 [text-stroke:2px_#310031] [-webkit-text-stroke:2px_#310031]'
            }
        ]);

        // Example: Additional observable for about content (can be loaded from Firestore)
        this.aboutContent = ko.observable(options.aboutContent || '');
    }
    // Optionally, add methods to fetch about content from Firestore or other sources
}

export default AboutViewModel;
